<template>
    <sa-page-layout :btnSaveVisible="true" :btnSaveNotBackVisible="true" :linkNotBack="linkNotBack" @aftersave="onAfterSave" :btnAnnullaVisible="true" :linkback="linkback" :data="jsonData" :showModalLoading="showModalLoading" :pathResource="pathResource">
        <template slot="toolbar-title">
            <rsa-ospite-anagrafica-component :jsonData="jsonData"></rsa-ospite-anagrafica-component>
        </template>
        <template slot="toolbar">
            <b-button size="sm" variant="success btn-toolbar sa-margin-right float-sm-right" :hidden="btnSalvaSchedaPaziente" @click="onClickSalvaSchedaPaziente">
                <b-icon icon="plus"></b-icon>
                Salva Scheda Paziente
            </b-button>
            <!-- <b-button size="sm" variant="btn--md btn-light waves-effect waves-light btn-toolbar  float-sm-right" @click="loadStampeReport" :hidden="isBtnStampa">
				<b-icon icon="printer"></b-icon>
				Stampa
			</b-button> -->
        </template>
        <template slot="table-body">
            <rsa-accettazione-edit-component ref="cmpRsaAccettazioneEditComponent" :showModalLoading="showModalLoading" @update="onUpdateJsonData" @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData" @onActiveTab="onActiveTab" :key="componentKey"></rsa-accettazione-edit-component>
            <modal-error ref="cmpModalError"></modal-error>
        </template>
    </sa-page-layout>
</template>

<script>
import axios from "axios";
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RsaOspiteAnagraficaComponent from "../../rsagestioneospiti/components/RsaOspiteAnagraficaComponent.vue";
import UtilityMixin from "../../../utility/UtilityMixin";
import ModalError from "../../../../template/components/modal/components/ModalError.vue";
import RsaAccettazioneEditComponent from "../../rsaaccettazione/components/RsaAccettazioneEditComponent.vue";
export default {
    props: {
        utente: { type: Object },
    },
    components: {
        ModalError,
        SaPageLayout,
        RsaOspiteAnagraficaComponent,
        RsaAccettazioneEditComponent,
    },
    mixins: [UtilityMixin],
    data() {
        return {
            idAccettazione: null,
            btnNuovaRichiestaEsameHidden: true,
            btnNuovaRichiestaUscita: true,
            idRisorsa: null,
            filtro: {},
            btnNewVisible: true,
            pathResource: "/rsaaccettazioni",
            pathResourceAccettazione: "/rsaaccettazioni",
            linkedit: "",
            linkback: "/rsapaziente/schedaospite",
            showModalLoading: false,
            linkPrintData: "",
            linkNotBack: "",
            listKey: 0,
            activeTabIndex: 0,
            componentKey: 0,
            btnSalvaSchedaPaziente: true,
            isBtnStampa: true,
            jsonData: { accettazioneAnagrafica: {}, accettazionePrestazioni: {}, accettazioneStati: [], accettazioneStruttura: {}, accettazionePresidio: {} },
        };
    },
    mounted() {
        let me = this;
        me.idAccettazione = this.$route.params.id ? this.$route.params.id : this.$route.query.idAccettazione;
        me.idRisorsa = me.idAccettazione;
        me.linkPrintData = "/rsaaccettazioni/printdata/" + me.idAccettazione;
        this.linkback += "?idAccettazione=" + me.idAccettazione;
        me.loadAccettazione();
    },
    methods: {
        loadAccettazione() {
            let me = this;
            me.showModalLoading = true;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceAccettazione + "/" + me.idAccettazione;
            axios
                .get(link)
                .then((response) => {
                    me.jsonData = response.data.data;
                    me.$refs.cmpRsaAccettazioneEditComponent.loadData();
                    me.showModalLoading = false;
                })
                .catch(() => {
                    me.showModalLoading = false;
                });
        },
        onInputTabs(index) {
            let me = this;
            let activeTab = this.$refs.tabsRsaAccettazioneEdit.getTabs()[index];

            me.activeTab(activeTab.id);
        },
        activeTab(idActiveTab) {
            let me = this;
            me.isBtnStampa = false;
            me.btnSalvaSchedaPaziente = true;
            switch (idActiveTab) {
                // case "tbPersoneRiferimento":
                //     me.$refs.cmpRsaPersonaRiferimento.loadData(me.idAccettazione);
                //     break;
                // case "tbImpegnativa":
                //     me.$refs.cmpRsaImpegnativaList.loadData(me.idAccettazione);
                //     break;
                // case "tbSpeseExtra":
                //     me.$refs.cmpRsaSpesaExtraList.setId(me.idAccettazione);
                //     break;
                // case "tbPresenza":
                //     me.$refs.cmpRsaUsciteList.init(me.jsonData);
                //     break;
                // case "tbImpegnative":
                //     me.$refs.cmpRsaImpegnativeListComponent.init(me.jsonData);
                //     break;
                // case "tbAnagrafica":
                //     me.$refs.cmpRsaAccettazioneAnagraficaViewComponent.setId(me.idAccettazione);
                //     me.isBtnStampa = true;
                //     break;
                // case "tbDatiFatturazione":
                //     me.$refs.cmpRsaAccettazioneDatiFatturazione.init(me.jsonData);
                //     break;
                case "tbRsaSchedaPaziente":
                    me.btnSalvaSchedaPaziente = false;
                    break;
                // case "tbDimissioniTrasferimeti":
                //     me.$refs.cmpRsaDimissioneTrasferimento.setId(me.idAccettazione);
                //     break;
            }
        },
        loadStampeReport() {
            let me = this;
            // me.printData = {};
            me.loadDataResources(me.linkPrintData, null, me.resultResponseStampa, me.resultErrorStampa);
        },
        resultResponseStampa(response) {
            let me = this;
            me.reportName = response.data.data.reportName;
            me.printData = response.data.data;

            me.$refs.cmpPrint.print(response.data.data);
        },
        resultErrorStampa(error) {
            let me = this;
            let messaggio = error.response.messaggio ? error.response.messaggio : "Stampa non disponibile";
            me.$refs.cmpModalError.show(messaggio + "#");
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onBeforeloadData() {
            let me = this;
            me.showModalLoading = true;
        },
        onUpdateIdDocumentRepository(id) {
            let me = this;
            me.idRisorsa = id;
        },
        onUpdateJsonData(data) {
            let me = this;
            me.jsonData = data;
        },
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
        onAfterSave(data) {
            let me = this;
            me.loadData();
            me.showModalLoading = false;
            me.id = data.id;
            me.jsonData = {
                ...me.jsonData,
                id: data.id,
            };
        },
        onActiveTab(idActiveTab) {
            let me = this;
            me.setCommand(idActiveTab);
        },
        setCommand(idActiveTab) {
            let me = this;
            me.btnSalvaSchedaPaziente = true;
            switch (idActiveTab) {
                case "tbRsaSchedaPaziente":
                    me.btnSalvaSchedaPaziente = false;
                    break;
            }
        },
        onClickSalvaSchedaPaziente() {
            let me = this;
            me.$refs.cmpRsaAccettazioneEditComponent.salvaSchedaPaziente();
        },
    },
};
</script>

<style></style>
